import React from 'react';
import {Text} from 'react-native';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';
import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import Checkbox from '../Checkbox';

export default () => (
  <>
    <Heading level={1}>Checkbox</Heading>
    <Spacer size={16} />
    <Text>
      By default the <Code>Checkbox</Code> component uses the current user's
      competency level to determine its color.
    </Text>
    <Spacer size={16} />
    <FlexView direction="horizontal" expand={false}>
      <FlexView align="center" expand={false}>
        <Checkbox checked={true} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center" expand={false}>
        <Checkbox checked={false} />
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <Heading level={2}>Overriding Competency Level</Heading>
    <Spacer size={16} />
    <Text>
      When the <Code>competency</Code> prop is set to a valid value it will
      override the current user's competency level and the corresponding color
      for the checkbox will be used instead.
    </Text>
    <Spacer size={16} />
    <FlexView expand={false}>
      <FlexView direction="horizontal" expand={false}>
        <FlexView align="center" expand={false}>
          <Checkbox checked={true} competency={COACH} />
        </FlexView>
        <Spacer direction="horizontal" size={16} />
        <FlexView align="center" expand={false}>
          <Checkbox checked={false} competency={COACH} />
        </FlexView>
      </FlexView>
      <Spacer size={6} />
      <Code>{'competency={COACH}'}</Code>
    </FlexView>
    <Spacer size={10} />
    <FlexView expand={false}>
      <FlexView direction="horizontal" expand={false}>
        <FlexView align="center" expand={false}>
          <Checkbox checked={true} competency={BUSINESS_COACH} />
        </FlexView>
        <Spacer direction="horizontal" size={16} />
        <FlexView align="center" expand={false}>
          <Checkbox checked={false} competency={BUSINESS_COACH} />
        </FlexView>
      </FlexView>
      <Spacer size={6} />
      <Code>{'competency={BUSINESS_COACH}'}</Code>
    </FlexView>
    <Spacer size={10} />
    <FlexView expand={false}>
      <FlexView direction="horizontal" expand={false}>
        <FlexView align="center" expand={false}>
          <Checkbox checked={true} competency={BUSINESS_LEADER} />
        </FlexView>
        <Spacer direction="horizontal" size={16} />
        <FlexView align="center" expand={false}>
          <Checkbox checked={false} competency={BUSINESS_LEADER} />
        </FlexView>
      </FlexView>
      <Spacer size={6} />
      <Code>{'competency={BUSINESS_LEADER}'}</Code>
    </FlexView>
  </>
);
